export default __webpack_public_path__ + "static/dreifaltigkeit-1-9db34df3d406f8400b6fd6d7e55edf4f.png";